import React from 'react';
import { Link } from 'react-router-dom';
import { AuthLayout } from './AuthLayout';

export const VerifyOtpView: React.FC = () => {
  return (
    <AuthLayout>
      <div className="text-center">
        <h2 className="text-3xl font-bold tracking-tight text-gray-900">Verification Updated</h2>
        <p className="mt-2 text-sm text-gray-600">
          Phone OTP is no longer required. Please log in with your email and password.
        </p>
      </div>

      <div className="mt-8 space-y-6 w-full">
        <Link
          to="/login"
          className="flex w-full justify-center rounded-xl bg-blue-500 px-4 py-3 text-sm font-semibold text-white shadow-sm hover:bg-blue-600 transition-all"
        >
          Go to Login
        </Link>

        <div className="pt-4 border-t border-gray-100 flex items-center justify-center gap-2 text-xs text-gray-400">
          <svg className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
          </svg>
          Your data is secure and encrypted
        </div>
      </div>
    </AuthLayout>
  );
};
